/*
 * Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { createContext, useReducer } from "react";
import { FieldContextReducer } from "cms/fields/context/reducer";

export const FieldZoneContext = createContext([{}, (obj) => obj]);

const FieldZoneProvider = (props) => {
    
    const initState = props?.initState;
    const children = props?.children;
    
    const [state, dispatch] = useReducer(FieldContextReducer, initState);
    
    const fieldZoneContext = { state, dispatch };

    return (
        <FieldZoneContext.Provider value={fieldZoneContext}>
            {children}
        </FieldZoneContext.Provider>
    );
};

export { FieldZoneProvider };
